module.exports = __webpack_public_path__ + "img/bitrix.18ab1a52.png";